'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _querystring = require('./querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _reducers = require('../core/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _store = require('../core/store');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionType = 'NAVIGATOR/NAVIGATE';

function navigate(objOrCallback, $element) {
    var url = window.location.href;
    if ((0, _isObject2.default)(objOrCallback)) {
        url = _querystring2.default.update(url, function (qs) {
            (0, _forOwn2.default)(objOrCallback, function (v, k) {
                if (v === "" || typeof v === 'undefined' || v === null) {
                    delete qs[k];
                } else {
                    qs[k] = v;
                }
            });
        });
    } else if ((0, _isFunction2.default)(objOrCallback)) {
        url = _querystring2.default.update(url, function (qs) {
            return objOrCallback(qs) || qs;
        });
    }

    if (url !== window.location.href) {
        var data = buildNavigateData($element);
        window.history.pushState(data, '', url);
        dispatchEvent(url, data);
        return true;
    }
    return false;
}

function buildNavigateData($element) {
    var ajaxElement = $element.attr('data-query-target');
    if (!ajaxElement) {
        var id = $element.closest('[data-ajax="true"]').attr('id');
        if (id) ajaxElement = '#' + id;
    }
    return { ajaxElement: ajaxElement };
}

function dispatchEvent(uri, extraData) {
    (0, _store.dispatchAction)(_extends({ type: ActionType, uri: uri }, extraData));
}

var _callbacks = [];
// event subscription
function onNavigate(callback) {
    _callbacks.push(callback);
    return function () {
        var index = _callbacks.indexOf(callback);
        _callbacks.splice(index, 1);
    };
}

var lastUrl = window.location.href;

window.onpopstate = function (event) {
    if (window.location.href !== lastUrl) {
        dispatchEvent(window.location.href, event.state);
    }
    lastUrl = window.location.href;
};

_reducers2.default.add('nav', function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case ActionType:
            setTimeout(function () {
                _callbacks.forEach(function (c) {
                    return c(action);
                });
            }, 0);
    }
    return state;
});

exports.default = { navigate: navigate, onNavigate: onNavigate };


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/navigator.js
// module id = 411
// module chunks = 0